import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { IFileUpload } from '../../interfaces';
import { CAMERA_CONFIG, IRoblexCameraConfig } from './camera.config';

@Injectable({ providedIn: 'root' })
export class CameraService {
    constructor(
        @Optional() @Inject(CAMERA_CONFIG) private configCameraValue: IRoblexCameraConfig,
        private http: HttpClient
    ) {
        // console.warn(this.configCameraValue);
    }

    upload(file: any): Observable<IFileUpload> {
        const formData = new FormData();

        formData.append('file', file);

        return this.http.post<IFileUpload>(this.configCameraValue.api, formData);
    }
}
